import { Outlet } from 'react-router-dom'
import { DesktopSidebar } from "@/components/themeComponent/dashboard/SidebarContent";
import DashboardHeader from "@/components/themeComponent/dashboard/dashboardHeader";
import { useSidebar } from "@/components/app/SidebarContext";

function DashboardContent() {
  const { collapsed, setCollapsed, collapsedByBtn } = useSidebar();

  return (
    <div className=" bg-background">
      <div className={`hidden lg:block transition-[width] md:pl-5 md:py-5 bg-background top-0 bottom-0 left-0 fixed z-30 duration-300 ease-in-out h-full ${collapsed ? "w-[120px]" : "w-[310px]"}`}
        onMouseEnter={() => {
          if (collapsedByBtn) {
            setCollapsed(false);
          }
        }}
        onMouseLeave={() => {
          if (collapsedByBtn) {
            setCollapsed(true);
          }
        }}
      >
        <DesktopSidebar />
      </div>
      <div className={`relative transition-all duration-300 ease-in-out ${collapsed ? 'lg:ml-[120px]' : 'lg:ml-[310px]'}`}>
        {/* <div className="max-w-[1292px] mx-auto"> */}
          <div className="md:px-5 sticky top-0 z-30 w-full bg-background md:p-5 ">
          <div className="">
            <DashboardHeader />
          </div>
        </div>
        <main className="md:p-5 p-4 md:pt-0">
          <Outlet />
        </main>
        {/* </div> */}
      </div>
    </div>
  );
}

export default function DashboardLayout() {
  return <DashboardContent />;
}
